import { FormShape, FormUnit } from "@suse-o11y/signal/form";

import { isStringDirty } from "~/tools/is-string-dirty";

import { type DashboardTextVariable, dashboardTextVariableSchema } from "../../../common/dashboard-spec";
import type { FormProcessor } from "../_form-processor";

const shapeSchema = dashboardTextVariableSchema.removeCatch().shape;

export type FormState = FormShape<{
	value: FormUnit<string, ReadonlyArray<string>>;
	readOnly: FormUnit<boolean>;
}>;

export const Processor: FormProcessor<FormState, undefined | DashboardTextVariable> = {
	fromSpec: (spec) =>
		FormShape({
			value: FormUnit(spec?.value ?? "", {
				isInputDirty: isStringDirty,
				schema: shapeSchema.value.removeCatch(),
			}),
			readOnly: FormUnit(spec?.constant ?? false),
		}),

	toSpec: ({ value, readOnly }) => ({
		value,
		constant: readOnly,
	}),
};
